// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3l_bf","title":"ClientInsurance_title__12pcO","itemText":"ClientInsurance_itemText__3d2rX"};